import styled from 'styled-components'

export const ContainerObject = styled.div`
    padding: 20px;
    background-color: #fbfbfb;
`